import { $, $$ } from '@3pc/dom';
import { Accordion } from '@3pc/accordion';
import { uniqueId } from '../../../shared/js/utils/helper';

class Header {
  constructor(params) {
    this.container = params.container;
    this.breakpoint = params.breakpoint;
    this.burgerBtn = $('.btn--burger', this.container);
    this.mobileAccordion = [];
    this.mobileAccordionInitiated = false;
    this.firstLevelAccordions = [];
    this.closeButtons = $$('.navigation__level-2-close-icon', this.container);
  }

  initBurgerMenu = () => {
    const handler = this.burgerBtn;
    const target = $('.header__navigation', this.container);
    const targetInner = $('.navigation', this.container);

    this.mobileAccordion = new Accordion({
      handler,
      target,
      targetInner,
      easing: 'easeInOutCubic',
      duration: 400,
      openClassName: 'is-active',
    });

    if (
      window.innerWidth <= this.breakpoint &&
      !this.mobileAccordionInitiated
    ) {
      this.mobileAccordion.init();
      this.mobileAccordionInitiated = true;
    }
  };

  initFirstLevelAccordions = () => {
    const firstLevelItems = $$('.navigation__level-1-item', this.container);

    firstLevelItems.length &&
      firstLevelItems.forEach(item => {
        const handler = $('.navigation__level-1-btn', item);
        const target = $('.navigation__level-2-wrapper', item);
        const targetInner = $('.navigation__level-2-inner', item);

        if (handler) {
          this.firstLevelAccordion = new Accordion({
            handler,
            target,
            targetInner,
            easing: 'easeInOutCubic',
            duration: 400,
            openClassName: 'is-active',
          });

          this.firstLevelAccordions.push(this.firstLevelAccordion);
        }

        this.firstLevelAccordions.forEach(accordion => {
          accordion.closeInstances = this.firstLevelAccordions.filter(
            item => item !== accordion
          );
          if (accordion.closeInstances !== 'undefined') accordion.init();
        });
      });
  };

  closeOnEsc = evt => {
    if (evt.code === 'Escape' && window.innerWidth <= this.breakpoint) {
      this.mobileAccordion && this.mobileAccordion.close();
    } else if (evt.code === 'Escape' && window.innerWidth > this.breakpoint) {
      this.firstLevelAccordions.forEach(accordion => {
        accordion.close();
      });
    }
  };

  closeSecondLevel = () => {
    if (this.mobileAccordionInitiated) {
      this.mobileAccordion.close();
    } else {
      this.firstLevelAccordions.forEach(accordion => {
        accordion.close();
      });
    }
  };

  handleKeyboardFocus = evt => {
    // go back to burger button in mobile view
    if (window.innerWidth <= this.breakpoint) {
      const mobileTeaser = $(
        '.navigation__page-teaser--mobile',
        this.container
      );
      const pageTeaser = $$('.page-teaser__item-link', mobileTeaser);

      if (pageTeaser.length) {
        const lastTeaser = pageTeaser[pageTeaser.length - 1];
        lastTeaser.addEventListener('keydown', e => {
          if (e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            this.burgerBtn.focus();
          }
        });
      }
    }
  };

  handleSecondLevelTeasers = () => {
    if (window.innerWidth > this.breakpoint) {
      const teaserText = $$('.navigation__level-2-teaser', this.container);
      if (teaserText.length) {
        teaserText.forEach(item => {
          const randomId = uniqueId();
          const teaserId = `teaser-${randomId}`;
          const parentLink = item.parentElement.firstElementChild;
          parentLink.setAttribute('aria-describedby', teaserId);
          item.firstElementChild.setAttribute('id', teaserId);
        });
      }
    }
  };

  handleResize = () => {
    if (window.innerWidth <= this.breakpoint) {
      if (!this.mobileAccordionInitiated) {
        this.burgerBtn && this.initBurgerMenu();
        this.mobileAccordionInitiated = true;
      }
    } else {
      if (this.mobileAccordionInitiated) {
        this.mobileAccordion && this.mobileAccordion.destroy();
        this.mobileAccordionInitiated = false;
        this.mobileAccordion = null;
      }
    }
  };

  bindEvents = () => {
    // closeOnEscape /handleKeyboardFocus
    window.addEventListener('keydown', evt => {
      this.closeOnEsc(evt);
      this.handleKeyboardFocus(evt);
    });

    // handle second level close buttons
    this.closeButtons.length &&
      this.closeButtons.forEach(btn => {
        btn.addEventListener('click', this.closeSecondLevel);
        btn.addEventListener('keydown', evt => {
          const parentAccordion = this.firstLevelAccordions.find(item =>
            item.handler.classList.contains('is-active')
          );
          if (evt.key === 'Enter' && !evt.shiftKey && parentAccordion) {
            evt.preventDefault();
            this.closeSecondLevel();
            parentAccordion.handler.focus();
          }
        });
      });

    this.handleSecondLevelTeasers();
    window.addEventListener('resize', () => this.handleResize());
  };

  init = () => {
    this.bindEvents();
    this.burgerBtn && this.initBurgerMenu();
    this.initFirstLevelAccordions();
  };
}

const header = $('.header');

if (header) {
  const burgerBtn = $('.btn--burger', header);
  burgerBtn &&
    new Header({
      container: header,
      breakpoint: 1200,
    }).init();
}
